// extracted by mini-css-extract-plugin
export default {"container":"style_container__WMP7M","card":"style_card__L6lan","row":"style_row__qxrw1","btnsRow":"style_btnsRow__BFn6Y","amountDiv":"style_amountDiv__WZ5RW"};